import { render } from "./ChannelSegmentsForBridgePlacement.vue?vue&type=template&id=4b513732&ts=true"
import script from "./ChannelSegmentsForBridgePlacement.vue?vue&type=script&lang=ts"
export * from "./ChannelSegmentsForBridgePlacement.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__